<template>
  <transition name="fade">
    <div class="seating-tables-wrapper" v-show="showSeatingTables">
      <div class="seating-tables__title">Get Social! Hop to Any Room</div>
      <div class="seating-tables">
        <a
          class="seating-table"
          v-for="table in seatingTables"
          :key="table.id"
          :href="table.url"
          target="_blank"
        >
          <div class="seating-table__label">
            <div>{{ seatingTableLabel(table) }}</div>
          </div>
          <div class="seating-table__text">
            <div class="seating-table__title">{{ table.title }}</div>
            <!-- <div class="seating-table__host">Hosted by {{ table.host_name }}</div> -->
          </div>
        </a>
      </div>
      <div class="seating-tables-mobile">
        <v-select
          :items="seatingTables"
          :item-text="seatingTableItemText"
          item-value="url"
          label="Select Your Table"
          v-model="selectedSeatingTable"
          v-on:change="seatingTableSelected"
        ></v-select>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    seatingTables: Array
  },
  data() {
    return {
      selectedSeatingTable: Object,
      showSeatingTables: false
    };
  },
  channels: {
    SeatingTableChannel: {
      connected() {
        console.log("Connected SeatingTableChannel");
      },
      rejected() {
        console.log("Rejected SeatingTableChannel");
      },
      received({ payload }) {
        this.showSeatingTables = payload.show;
      }
    }
  },
  async mounted() {
    const { data } = await this.$api.SiteOption.query({
      name: "show_seating_tables"
    });
    this.showSeatingTables = data.enabled;
    this.$cable.subscribe({
      channel: "SeatingTableChannel"
    });
  },
  methods: {
    seatingTableSelected() {
      if (this.selectedSeatingTable) {
        window.open(this.selectedSeatingTable, "_blank");
      }
    },
    seatingTableLabel: table =>
      table.position < 10 ? "0" + table.position : table.position,
    seatingTableItemText: item => item.title + ", Hosted by " + item.host_name
  },
  beforeDestroy() {
    this.$cable.unsubscribe({
      channel: "SeatingTableChannel"
    });
  }
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.seating-tables {
  &-wrapper {
    margin: 0 120px;
  }

  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin: 0 -10px;

  &__title {
    font-weight: 700;
    font-size: 36px;
    line-height: 1.125;
    margin: 50px 0 23px;
    color: $stjude-red;
  }

  > a {
    flex-basis: calc(33% - 20px);
  }
  &-mobile {
    width: 1px;
    height: 1px;
    opacity: 0;
    &::v-deep {
      .theme--light.v-select .v-select__selection--comma {
        color: $stjude-red;
      }
      .theme--light.v-label {
        color: $stjude-red;
        font-weight: 700;
        font-size: 20px;
        opacity: 0.3;
      }
      .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: none;
      }
      .v-select {
        border: 1px solid #d11947;
        padding: 11px 18px 11px 20px;
        .v-icon.v-icon {
          color: $stjude-red;
          font-size: 37px;
        }
        .v-text-field__details {
          display: none;
        }
        .v-input__slot {
          margin-bottom: 0;
        }
      }
    }
  }
}

.seating-table {
  text-decoration: none;
  border-radius: 5px;
  padding: 20px;
  margin: 10px;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  &:hover {
    .seating-table__title {
      text-decoration: underline;
    }
  }
  &__label {
    font-size: 36px;
    color: white;
    font-family: "Open Sans", sans-serif;
    min-width: 70px;
    height: 70px;
    border-radius: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:nth-child(2n + 1) .seating-table__label {
    background-color: $stjude-red;
  }
  &:nth-child(2n + 0) .seating-table__label {
    background-color: $stjude-light-gray;
    color: $stjude-red;
  }

  &__text {
    margin-left: 20px;
  }
  &__title {
    font-weight: 700;
    font-size: 20px;
    line-height: 1.55;
  }
  &__host {
    font-weight: 700;
    font-size: 12px;
    line-height: 1.33;
  }
}

@media screen and (max-width: 1120px) {
  .seating-tables > a {
    flex-basis: calc(33% - 20px);
  }
}

@media screen and (max-width: 960px) {
  .seating-tables {
    display: none;
    &__title {
      font-size: 32px;
    }
    &-mobile {
      width: unset;
      height: unset;
      opacity: 1;
    }
    &-wrapper {
      margin: 0 20px;
    }
  }
}
</style>
